import { FC } from 'react';
import { Route, Switch } from 'react-router-dom';
import BoardInquiry from '../pages/board/inquiry';
import BoardInquiryCreate from '../pages/board/inquiry/create';
import BoardInquiryRead from '../pages/board/inquiry/read';
import BoardInquiryEdit from '../pages/board/inquiry/edit';
import BoardNotice from '../pages/board/notice';
import BoardNoticeCreate from '../pages/board/notice/create';
import BoardNoticeRead from '../pages/board/notice/read';
import BoardNoticeEdit from '../pages/board/notice/edit';

const BoardRouter: FC = () => {
  return (
    <Switch>
      <Route path='/board/notice' exact component={BoardNotice} />
      <Route path='/board/notice/create' exact component={BoardNoticeCreate} />
      <Route path='/board/notice/:noticeCode' exact component={BoardNoticeRead} />
      <Route path='/board/notice/:noticeCode/edit' exact component={BoardNoticeEdit} />
      <Route path='/board/inquiry' exact component={BoardInquiry} />
      <Route path='/board/inquiry/create' exact component={BoardInquiryCreate} />
      <Route path='/board/inquiry/:communicationCode' exact component={BoardInquiryRead} />
      <Route path='/board/inquiry/:communicationCode/edit' exact component={BoardInquiryEdit} />
    </Switch>
  )
}

export default BoardRouter;
